<ng-content select="[changeDeviceLink]"></ng-content>
<!--EIP Eligibility heading-->
<div class="row" *ngIf="false">
  <div class="col-12 m-b-md">
    <p class="alert-text m-t-xl">
      <i class="fa fa-flag def alert-icon"></i>{{ pdpStaticContent?.deviceInEligibleEIP }}
    </p>
    <hr class="divider m-t-xl" />
  </div>
</div>
<div class="row m-t-xl">
  <div class="col-12 col-md-4 col-lg-4 xs-m-t-lg">
    <div *ngIf="bannerText" class="callout-icon n-margin-t">
      <p class="xsmall">
        {{ bannerText }}
      </p>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center" *ngIf="mainImageUrl; else noImageAvailable">
        <img
          class="img-fluid inline-block"
          [src]="mainImageUrl || ''"
          alt="{{ deviceDetails?.familyName }}"
          id="device-image"
        />
      </div>
      <ng-template #noImageAvailable>
        <div class="col-sm-12 text-center">
          <img id="no-image" class="img-fluid inline-block" [src]="dummyImage" alt="FPO Image" />
        </div>
      </ng-template>
    </div>
    <tmo-product-gallery
      *ngIf="selectedDevice?.carousalImages?.length"
      [carousalImages]="selectedDevice?.carousalImages"
      [carousalLength]="carousalLength"
      (activeImagePath)="updateImagePath($event)"
    ></tmo-product-gallery>
    <ng-content *ngIf="!(isExistingLine && !isUpgrade)" select="[displayCPO]"></ng-content>
    <div
      class="col-12 offset-2 m-t-xl"
      *ngIf="!isEpin && deviceDetails?.type?.toLowerCase() !== accessoryConstant"
    ></div>
  </div>

  <div class="col-sm-12 col-md-8">
    <div class="row">
      <div class="col-12">
        <h3>
          {{ deviceDetails?.familyName }}
          <span *ngIf="!isUpgrade && selectedDevice?.memory && selectedDevice?.color">
            - {{ selectedDevice?.color }} - {{ selectedDevice?.memory }}</span
          >
        </h3>
        <span *ngIf="!(isEpin && !selectedEipAmount)">
          <span *ngIf="isAssistedFlow && !(isExistingLine && !isUpgrade)"
            >({{ pdpStaticContent?.sku }}:{{ selectedDevice?.id }})
          </span>
        </span>
      </div>
      <!-- <div class="col-12" *ngIf="!isWebChannel">
        <div class="inline-block">
          <tmo-star-rating *ngIf="!isProductSelector" [rating]="deviceDetails?.averageOverallRating" [showMediumStar]="true"></tmo-star-rating>
        </div>
        <div class="m-l-md inline-block align-text-bottom"> <a href="javascript:void(0)" tmoGoTopButton [goToTopRef]="'review-header'" id="device-reviews">
          <span class="center">{{noOfReviewsText}} </span>
          </a>
        </div>
      </div> -->
      <div class="col-12" *ngIf="!isProductSelector">
        <span *ngIf="!(isExistingLine && !isUpgrade)">
          <a
            href="javascript:void(0);"
            *ngIf="
              selectedDevice?.condition === 'New' ? selectedDevice?.hasCPO : selectedDevice?.hasNew
            "
            (click)="getCertifiedPreOwnDevice(selectedDevice?.hasCPO)"
            id="device-condition"
          >
            {{
              selectedDevice?.condition === 'New'
                ? pdpStaticContent?.seePreOwnedDevices
                : pdpStaticContent?.seeNewDevices
            }}
          </a>
        </span>
      </div>
      <!-- Deal Badge -->
    </div>
    <!--Deal Details-->
    <div
      *ngIf="
        !selectedDevice?.hasSale &&
        selectedDevice?.hasDeal &&
        selectedDevice?.itemPromotions &&
        !isExistingLine
      "
      class="row m-t-sm"
    >
      <div class="col-12">
        <div class="badge-magenta m-r-xs">
          <p class="legal">{{ selectedDevice?.dealText || pdpStaticContent?.dealEnd }}</p>
        </div>
        <a
          href="javascript:void(0)"
          *ngIf="selectedDevice?.itemPromotions[0]?.promoName"
          [innerHtml]="selectedDevice?.itemPromotions[0]?.promoName"
          (click)="showPromotionalModal(0)"
          id="device-promo"
        ></a>
      </div>
    </div>
    <div
      *ngIf="!selectedDevice?.hasSale && !selectedDevice?.hasDeal && !!selectedDevice?.dealText"
      class="row m-t-sm"
    >
      <div class="col-12">
        <div class="badge-magenta m-r-xs">
          <p class="legal">{{ selectedDevice?.dealText }}</p>
        </div>
      </div>
    </div>
    <tmo-devices-pricing-panel
      [deviceAmount]="
        isProductSelector && !noNeedPlan && !selectedPlanPrice && selectedPlanPrice !== 0
          ? selectedDevice?.priceWithService
          : selectedDevice?.salePrice
      "
      [id]="deviceDetails?.familyName"
      [isEpin]="isEpin"
      [selectedEipAmount]="selectedEipAmount"
      [pricingOptions]="epinPriceDetails"
      *ngIf="!(isExistingLine && !isUpgrade)"
      [aemContent]="pdpStaticContent"
      id="device-pricing"
    >
      <ng-container *ngIf="selectedDevice?.hasSale">
        <div class="badge-magenta m-r-sm m-l-md m-t-sm">
          <p class="legal">
            {{ selectedDevice?.dealText || pdpStaticContent?.sale }}
          </p>
        </div>
        <p class="m-t-lg sm-m-b-lg">{{ savedAmountText }}</p>
        <div class="col-12" *ngIf="!isP10MCustomer">
          <h5 class="md-m-l-md md-m-t-lg price-text n3 inline-block">
            <s
              ><sup class="n4">$</sup>{{ listPriceWholeNumber
              }}<sup class="n4">{{ listPriceDecimalNumber }}</sup></s
            >
          </h5>
        </div>
      </ng-container>
    </tmo-devices-pricing-panel>
    <ng-content select="[displaySimcardSkus]"></ng-content>
    <div class="row" *ngIf="isEpin">
      <div class="col-12">
        <p class="legal m-t-lg">{{ pdpStaticContent?.doesNotIncludeTaxOrShipping }}</p>
      </div>
    </div>
    <div class="row" *ngIf="!(isExistingLine && !isUpgrade)">
      <div class="col-12">
        <div class="m-b-sm" *ngIf="selectedPlanPrice && isProductSelector">
          <p class="small" *ngIf="selectedPlanPrice >= selectedDevice?.serviceThreshold">
            {{ pdpStaticContent?.congratulationMessage }}
          </p>
          <p class="small" *ngIf="selectedPlanPrice < selectedDevice?.serviceThreshold">
            {{ lowerPriceMessage }}
          </p>
        </div>
        <!-- <div *ngIf="deviceDetails?.type?.toLowerCase() !== 'accessory' && !isEpin && isAssisted">
          <p class="small" [innerHtml]="requirementForDevicePricing"></p>
        </div> -->
        <div
          class="m-t-sm"
          *ngIf="
            deviceDetails?.type?.toLowerCase() !== accessoryConstant &&
            !isSimCard &&
            !isEpin &&
            !selectedPlanPrice &&
            !noNeedPlan
          "
        >
          <p class="small">{{ deviceOnly }}</p>
        </div>
        <div class="row m-l-lg" *ngIf="isEpin">
          <div class="col-12 col-md-8">
            <ul class="m-t-sm bulleted-list ng-star-inserted m-l-xl">
              <li>
                <p>{{ deviceDetails?.longDescription }}</p>
              </li>
            </ul>
          </div>
        </div>
        <ng-content select="[epinPriceDropdown]"></ng-content>
        <div class="row m-t-lg" *ngIf="qtyList">
          <div class="col-1 m-t-sm m-r-lg">
            <p class="small inline-block">{{ pdpStaticContent?.qty }}</p>
          </div>
          <div class="col-4 col-6-sm col-6-xs col-lg-3" *ngIf="qtyList">
            <tmo-dropdown
              [options]="qtyList"
              [focusFirstElement]="true"
              name="pdpStaticContent?.quantity"
              [(ngModel)]="selectedQuantity"
              (selectionChange)="onUpdateQty(qty)"
              [id]="'tmo-dropdown-quantity-2'"
            >
            </tmo-dropdown>
          </div>
        </div>
        <!--Promotions start-->
        <div *ngIf="selectedDevice?.hasDeal && selectedDevice?.itemPromotions" class="m-t-lg">
          <div *ngFor="let promotion of selectedDevice?.itemPromotions; let promoIndex = index">
            <div *ngIf="promoIndex > 0 && !selectedDevice?.hasSale">
              <a
                href="javascript:void(0)"
                *ngIf="promotion?.promoName"
                [innerHtml]="promotion?.promoName"
                (click)="showPromotionalModal(promoIndex)"
                id="device-all-promos-{{ promoIndex }}"
              ></a>
            </div>
            <div *ngIf="selectedDevice?.hasSale">
              <a
                href="javascript:void(0)"
                *ngIf="promotion?.promoName"
                [innerHtml]="promotion?.promoName"
                id="device-sale-promo-{{ promoIndex }}"
                (click)="showPromotionalModal(promoIndex)"
              ></a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="deviceDetails?.type?.toLowerCase() !== 'accessory' && !isEpin && !isAssisted"> -->
      <div
        *ngIf="deviceDetails?.type?.toLowerCase() !== 'accessory' && !isEpin"
        [innerHTML]="pdpStaticContent?.finalPriceinCart"
      ></div>
      <div class="col-12" *ngIf="!isEpin && availabilityStatus">
        <p class="lead bold m-t-md">{{ availabilityStatus }}</p>
        <div *ngIf="availabilityStatus !== pdpStaticContent?.outOfStock">
          <ng-container *ngIf="hasEstimatedShippingDate; else elseBlock">
            <p class="lead m-t-md">{{ estimatedShippingText }}</p>
          </ng-container>
          <ng-template #elseBlock>
            <div class="col-12">
              <p class="lead m-t-md">{{ pdpStaticContent?.shipDateUnavailable }}</p>
            </div>
          </ng-template>
        </div>
      </div>
      <!-- Legal Disclaimer Section -->
      <ng-container *ngIf="isProductSelector && deviceDetails?.legalText">
        <div class="col-12">
          <div class="m-t-lg">
            <p class="legal">{{ deviceDetails?.legalText }}</p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div *ngIf="!isEpin && !isSimCard">
  <div class="row" tabindex="1" *ngIf="!(isExistingLine && !isUpgrade)">
    <div class="col-12 offset-sm-4 col-sm-8">
      <hr class="divider m-t-sm" />
      <h5 class="m-b-lg m-t-lg">{{ pdpStaticContent?.color }}</h5>
      <ng-container *ngIf="colorOptions; else noColorOption">
        <span class="color-radio" *ngFor="let item of colorOptions">
          <input
            type="radio"
            attr.aria-label="{{ item?.color }} {{ pdpStaticContent?.optionSelectedFor }} {{
              pdpStaticContent?.color
            }}"
            name="color-radio_sample"
            [checked]="selectedDevice?.color === item?.name"
            (click)="updateSelectedColor(item?.name)"
            id="device-color-{{ getColorName(item?.name) }}"
          />
          <span class="img-color">
            <img
              [src]="extTmoImagesUrl + item?.imagePath || ''"
              class="bg-gray-light"
              alt="Item Image"
              id="device-color-image"
            />
            <p class="xsmall break-word">{{ item?.name }}</p>
          </span>
        </span>
      </ng-container>
      <ng-template #noColorOption>
        <span class="color-radio">
          <input
            type="radio"
            attr.aria-label="{{ selectedDevice?.color }} {{
              pdpStaticContent?.optionSelectedFor
            }} {{ pdpStaticContent?.color }}"
            name="color-radio_sample"
            [checked]="true"
            id="device-color-radio1"
          />
          <span class="img-color">
            <img
              [src]="extTmoImagesUrl + selectedDevice?.skuImageUrl || ''"
              class="bg-gray-light"
              alt="Item Image"
              id="device-color-image1"
            />
            <p class="xsmall break-word">{{ selectedDevice?.color }}</p>
          </span>
        </span>
      </ng-template>
    </div>
  </div>
  <!--Memory-->
  <div
    class="col-12 offset-sm-4 col-sm-8"
    *ngIf="!(isExistingLine && !isUpgrade) && deviceDetails?.type?.toLowerCase() !== 'accessory'"
  >
    <hr class="divider m-t-xl" />
    <h5 class="m-b-lg m-t-lg">{{ pdpStaticContent?.memory }}</h5>
    <ng-container *ngIf="memoryOptions; else noOptions">
      <span *ngFor="let memoryOption of memoryOptions; let ind = index">
        <span class="memory-radio" *ngIf="memoryOption?.available">
          <input
            type="radio"
            attr.aria-label="{{ memoryOption?.memory }} {{ pdpStaticContent?.optionSelectedFor }} {{
              pdpStaticContent?.memory
            }}"
            name="memoryOption?.name"
            [value]="memoryOption?.value"
            *ngIf="memoryOption?.available"
            [checked]="memoryOption?.value === selectedDevice?.memory"
            (click)="updateSelectedMemory(memoryOption?.value)"
            id="device-memory-{{ memoryOption?.name }}"
          />
          <span class="memory-box" *ngIf="memoryOption?.available">
            <p class="small">{{ memoryOption?.name }}</p>
          </span>
        </span>
      </span>
    </ng-container>
    <ng-template #noOptions>
      <span class="memory-radio">
        <input
          type="radio"
          attr.aria-label="{{ selectedDevice?.memory }} {{ pdpStaticContent?.optionSelectedFor }} {{
            pdpStaticContent?.memory
          }}"
          [checked]="true"
          id="btn-radio-memory"
        />
        <span class="memory-box">
          <p class="small">{{ memory }}</p>
        </span>
      </span>
    </ng-template>
  </div>
  <!--SIM-->
  <div
    class="col-12 offset-sm-4 col-sm-8"
    *ngIf="
      !(isExistingLine && !isUpgrade) &&
      deviceDetails?.type?.toLowerCase() !== 'accessory' &&
      esimActivationsEnabled &&
      (selectedDevice?.simInfo?.simType || (deviceSimInfo && deviceSimInfo.length > 0))
    "
  >
    <hr class="divider m-t-xl" />
    <h5 class="m-b-lg m-t-lg">{{ pdpStaticContent?.simType }}</h5>
    <ng-container *ngIf="deviceSimInfo; else noOptions">
      <span *ngFor="let deviceSim of deviceSimInfo; let ind = index">
        <span class="memory-radio">
          <input
            type="radio"
            attr.aria-label="{{ deviceSim?.simType }} {{ pdpStaticContent?.optionSelectedFor }} {{
              pdpStaticContent?.simType
            }}"
            name="deviceSim?.simType"
            [value]="deviceSim?.simType"
            [checked]="
              deviceSim?.simType?.toLocaleLowerCase() ===
              selectedDevice?.simInfo?.simType?.toLocaleLowerCase()
            "
            (click)="updateSelectedSimInfo(deviceSim)"
            id="device-simType-{{ deviceSim?.simType }}"
          />
          <span class="memory-box">
            <p class="small">{{ deviceSim?.simType }}</p>
          </span>
        </span>
      </span>
      <ng-container *ngIf="isEsimEnabled">
        <ng-container>
          <div class="m-t-lg">
            <p *ngIf="isShowEsim">{{ pdpStaticContent?.eSIMInfo }}</p>
            <p *ngIf="!isShowEsim">{{ pdpStaticContent?.pSIMInfo }}</p>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #noOptions>
      <span class="memory-radio">
        <input
          type="radio"
          attr.aria-label="{{ selectedDevice?.simInfo?.simType }} {{
            pdpStaticContent?.optionSelectedFor
          }} {{ pdpStaticContent?.simType }}"
          [checked]="true"
          id="btn-radio-memory"
        />
        <span class="memory-box">
          <p class="small">{{ selectedDevice?.simInfo?.simType }}</p>
        </span>
      </span>
    </ng-template>
  </div>
</div>
<tmo-dynamic-modal [modal]="modal" (onHide)="closeModal()">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        tabindex="0"
        [attr.aria-label]="pdpStaticContent?.clickToClose"
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closeModal()"
        id="cta-click-to-close-2"
      >
        <i class="fa fa-times"></i
      ></a>
    </div>
    <div class="row">
      <div class="col-12">
        <h3>{{ deviceDetails?.familyName }}</h3>
      </div>
    </div>
  </ng-container>
  <h4 class="m-t-md">{{ promoDescription?.shortDescription }}</h4>
  <p class="small m-t-lg">{{ promoDescription?.longDescription }}</p>
  <!-- <div class="m-t-lg" *ngIf="!isWebChannel">
    <div class="col-xs-12">
      <div class="rep-instruction">
        <h3>{{pdpStaticContent?.repInstructions}}</h3>
        <p class="m-t-lg">{{promoDescription?.alternateDescription}}</p>
      </div>
    </div>
  </div> -->
  <p class="small m-t-xl">{{ promoDescription?.legalText }}</p>
</tmo-dynamic-modal>
